var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderoverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2299 7.24806V21.1874H2.99805V7.24806L14.6143 0.278687L26.2299 7.24806Z",
    fill: "#FFA001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.23 7.24806V21.1874H14.6144V0.278687L26.23 7.24806Z",
    fill: "#F87F02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.24813L2.998 0.278442H14.6141L11.6161 7.24813H0Z",
    fill: "#FFDA2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2282 7.24813L26.2302 0.278442H14.6141L17.6121 7.24813H29.2282Z",
    fill: "#FCBE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73218 15.3463H8.60718V17.2213H6.73218V15.3463Z",
    fill: "#FFDA2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.8646C32 22.6515 28.93 25.7215 25.1431 25.7215C21.3556 25.7215 18.2856 22.6515 18.2856 18.8646C18.2856 15.0771 21.3556 12.0071 25.1431 12.0071C28.93 12.0071 32 15.077 32 18.8646Z",
    fill: "#83E470"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 18.8646C31.9999 22.6515 28.9299 25.7215 25.1431 25.7215V12.0071C28.9299 12.0071 31.9999 15.077 31.9999 18.8646Z",
    fill: "#01B763"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7312 17.754L25.1431 21.342L24.5212 21.964L21.5543 18.997L22.8806 17.6714L24.5212 19.312L25.1431 18.6902L27.4049 16.4283L28.7312 17.754Z",
    fill: "#F3FDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7312 17.754L25.1431 21.342V18.6902L27.4049 16.4283L28.7312 17.754Z",
    fill: "#D7F3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderoverview);
export default __webpack_public_path__ + "static/media/orderoverview.627ceca24c9a45ae542a6ac6dced4f7e.svg";
export { ForwardRef as ReactComponent };